import { render, staticRenderFns } from "./TransitionHouseholdTable.vue?vue&type=template&id=0bc1636c&scoped=true"
import script from "./TransitionHouseholdTable.vue?vue&type=script&lang=js"
export * from "./TransitionHouseholdTable.vue?vue&type=script&lang=js"
import style0 from "./TransitionHouseholdTable.vue?vue&type=style&index=0&id=0bc1636c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc1636c",
  null
  
)

export default component.exports